export function isLocalStorageSupported(): boolean {
  try {
    const uid = '__modernizr_localstorage__';
    const storage = window.localStorage;

    if (!storage) {
      return false;
    }

    storage.setItem(uid, uid)
    const support = storage.getItem(uid) === uid;
    storage.removeItem(uid);

    return support;
  } catch (e) {
    return false
  }
}

export function isSessionStorageSupported(): boolean {
  try {
    const uid = '__modernizr_sessionstorage__';
    const storage = window.sessionStorage;

    if (!storage) {
      return false;
    }

    storage.setItem(uid, uid)
    const support = storage.getItem(uid) === uid;
    storage.removeItem(uid);

    return support;
  } catch (e) {
    return false
  }
}

export async function isIndexedDBSupported(): Promise<boolean> {
  if (!window.indexedDB) {
    return false;
  }

  try {
    const dbName = '__modernizr_indexeddb__';
    const request = indexedDB.open(dbName);

    return new Promise((resolve) => {
      request.onerror = () => {
        resolve(false);
      }

      request.onsuccess = () => {
        request.result.close();
        indexedDB.deleteDatabase(dbName).onsuccess = () => resolve(true);
      };
    });

  } catch (e) {
    return false;
  }
}
